import { __rest } from 'tslib';
import React from 'react';
import { styled, LazyImage } from '@teko/ui';
import loading from '../../assets/images/loading.es.js';

const Wrapper = styled.div((props) => `
    width: ${props.size}px;
    height: ${props.size}px;
    position: relative;
  `);
const Logo = styled(LazyImage) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledLazyImage = styled(LazyImage) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  right: 0;
`;
const LogoLoading = (_a) => {
    var { size = 80, logo = '' } = _a, props = __rest(_a, ["size", "logo"]);
    return (React.createElement(Wrapper, Object.assign({}, props, { size: size }),
        logo && React.createElement(Logo, { width: size / 2, height: size / 2, src: logo }),
        React.createElement(StyledLazyImage, { width: size, height: size, src: loading })));
};

export { LogoLoading };
